import __request__ from "routing/request";
export function getRelevant(requestOptions) {
  return __request__("GET", "/system/configuration", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getRelevantByName(name, requestOptions) {
  return __request__("GET", `/system/configuration/${name}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
